export default __webpack_public_path__ + "static/media/home-banner-mobile.eb6b9970.png";